function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpIconStyle = function OwnUpIconStyle(props) {
  var baseSvgProps = {
    height: '100%',
    // Helps ensure icons are in-line with text baseline
    top: '0.125em',
    //  ...this is getting wacky - I need to rethink this variant system - BC
    position: 'relative',
    // Ensure color is propagated down to each icon
    stroke: props.color || colors.PRIMARY,
    fill: props.color || colors.PRIMARY
  };
  return createOwnUpStyle({
    width: props.width,
    height: props.height ? props.height : props.width ? undefined : '1em',
    display: 'inline-block',
    '& > svg': baseSvgProps,
    variants: {
      noTop: {
        '& > svg': _objectSpread(_objectSpread({}, baseSvgProps), {}, {
          top: 0
        })
      },
      block: {
        display: 'block'
      }
    }
  });
};
export var OwnUpStackedIconsStyle = function OwnUpStackedIconsStyle() {
  return createOwnUpStyle({
    '& > *': {
      position: 'absolute',
      display: 'inline-block',
      verticalAlign: 'middle'
    }
  });
};